import AudioRecorderComponent from './audio-recorder.component'

export default AudioRecorderComponent
